<template>
  <ElevationProfile
    :coordinates="measuredCoordinates"
    :color-scheme="colorScheme"
    :collapsible="false"
    :expandable="false"
    :title="$t('hike_map.measurement_elevation_profile_chart.elevation_profile')"
    @hover="onHover"
    @hover-end="onHoverEnd"
  />
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import ElevationProfile from '../../components/ElevationProfile.vue';

export default defineComponent({
  name: 'MeasurementElevationProfileChart',

  components: { ElevationProfile },

  data() {
    return {
      // Green scheme intentionally distinguishes the measurement tool from the
      // gold route/hike elevation profiles used elsewhere in the app.
      colorScheme: {
        line: '#4CAF50',
        fill: 'rgba(76, 175, 80, 0.2)',
        hoverLine: 'rgba(76, 175, 80, 0.5)',
      },
    };
  },

  computed: {
    ...mapGetters('hikeMeasurement', ['measuredGeoJson']),

    // Flatten the measured geometry into a single [lon, lat, ele] coordinate
    // array. buildElevationChartData (inside ElevationProfile) handles distance,
    // sampling, unit conversion and gain/loss from these raw coordinates.
    measuredCoordinates() {
      const geometry = this.measuredGeoJson && this.measuredGeoJson.geometry;
      if (!geometry) return [];

      if (geometry.type === 'LineString') {
        return Array.isArray(geometry.coordinates) ? geometry.coordinates : [];
      }

      if (geometry.type === 'MultiLineString') {
        const lines = Array.isArray(geometry.coordinates) ? geometry.coordinates : [];
        return lines.reduce(
          (acc, line) => (Array.isArray(line) ? acc.concat(line) : acc),
          []
        );
      }

      return [];
    },
  },

  methods: {
    ...mapActions('hikeMeasurement', ['setHoverCoordinate']),

    // Preserve hover → map behaviour: HikeMap.vue watches the Vuex
    // `hoverCoordinate` and places/moves the map marker itself, so we only feed
    // the hovered lng/lat into the store (no getMap on ElevationProfile, to
    // avoid a second, duplicate marker).
    onHover({ lngLat }) {
      if (lngLat) this.setHoverCoordinate([lngLat[0], lngLat[1]]);
    },

    onHoverEnd() {
      this.setHoverCoordinate(null);
    },
  },
});
</script>
